/* AlwaysCat — Gift Together (group gift pots). Start a pot, chip in, share. */
(function () {
  'use strict';

  var ALPHABET = 'abcdefghjkmnpqrstuvwxyz23456789';
  var EN = {
    js_add_error: 'Could not add your share. Please try again.', js_copied: 'Copied', js_copy_prompt: 'Copy this link',
    js_err_recipient: 'Tell us who the gift is for.', js_err_organiser: 'Add your first name, so friends know who is organising.',
    js_err_amount: 'Choose the amount of your share.', js_err_agree: 'Please tick the box to confirm how the pot works.',
    js_err_name: 'Add your name, so {name} knows who chipped in.', js_they: 'they', js_cat_lover: 'a cat lover',
    js_prop_gt: 'Gift Together', js_prop_link: 'Pot link', js_prop_msg: 'Message', js_prop_from: 'From',
    js_pot_for: 'Pot for {name}', js_share_for: 'Share for {name}', js_share_text: 'A group gift for {name} 🐾',
    js_to_go: '{amount} to go', js_goal: 'Goal reached 🎉'
  };
  function t(key, vars) {
    var dict = window.ACGT_T || {};
    var s = dict[key] || EN[key] || key;
    Object.keys(vars || {}).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  function rootPath() {
    var r = window.ACGT_ROOT;
    if (typeof r !== 'string') r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/').replace(/\/$/, '');
    return r;
  }

  function newCode() {
    var out = '';
    var bytes = new Uint32Array(6);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    for (var i = 0; i < bytes.length; i++) out += ALPHABET[bytes[i] % ALPHABET.length];
    return out;
  }

  function clean(value, max) {
    return String(value || '')
      .replace(/[|\r\n\t]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, max);
  }

  function currency() {
    var c = (window.Shopify && window.Shopify.currency) || {};
    return { code: c.active || 'CHF', rate: parseFloat(c.rate) || 1 };
  }

  function formatMoney(amount, code) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: code,
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
      }).format(amount);
    } catch (e) {
      return code + ' ' + Math.round(amount);
    }
  }

  function potUrl(code) {
    return window.location.origin + rootPath() + '/pages/gift-pot/' + code;
  }

  async function removeOtherPotShares(code) {
    var cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    var updates = {};
    (cart.items || []).forEach(function (item) {
      if (item.properties && item.properties._pot && item.properties._pot !== code) updates[item.key] = 0;
    });
    if (Object.keys(updates).length) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });
    }
  }

  async function addShare(variantId, code, properties) {
    await removeOtherPotShares(code);
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: properties }] }),
    });
    if (!res.ok) {
      var err = await res.json().catch(function () { return {}; });
      throw new Error(err.description || err.message || t('js_add_error'));
    }
    return res.json();
  }

  function selectedValue(form, name) {
    var input = form.querySelector('input[name="' + name + '"]:checked');
    return input ? input.value : '';
  }

  function setError(form, message) {
    var box = form.querySelector('[data-acgt-error]');
    if (!box) return;
    box.textContent = message || '';
    box.hidden = !message;
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.classList.toggle('is-busy', busy);
  }

  function copyText(text, button) {
    var done = function () {
      if (!button) return;
      var label = button.querySelector('[data-label]') || button;
      var original = label.textContent;
      label.textContent = t('js_copied');
      setTimeout(function () { label.textContent = original; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(done, function () { window.prompt(t('js_copy_prompt'), text); });
    } else {
      window.prompt(t('js_copy_prompt'), text);
    }
  }

  function wireShare(root, url, text) {
    root.querySelectorAll('[data-acgt-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () { copyText(url, btn); });
    });
    root.querySelectorAll('[data-acgt-invite]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: text, text: text, url: url }).catch(function () {});
        } else {
          copyText(url, btn);
        }
      });
    });
    root.querySelectorAll('[data-acgt-wa]').forEach(function (a) {
      a.href = 'https://wa.me/?text=' + encodeURIComponent(text + ' ' + url);
    });
    root.querySelectorAll('[data-acgt-mail]').forEach(function (a) {
      a.href = 'mailto:?subject=' + encodeURIComponent(text) + '&body=' + encodeURIComponent(text + '\n\n' + url);
    });
    root.querySelectorAll('[data-acgt-native]').forEach(function (btn) {
      if (!navigator.share) { btn.hidden = true; return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        navigator.share({ title: text, text: text, url: url }).catch(function () {});
      });
    });
  }

  function syncAmountButton(form) {
    var btn = form.querySelector('[data-acgt-submit]');
    var checked = form.querySelector('input[name="acgt-amount"]:checked');
    var slot = btn && btn.querySelector('[data-acgt-amount-label]');
    if (slot) slot.textContent = checked ? checked.getAttribute('data-price') : '';
  }

  /* ---------- Start a pot ---------- */
  function initStart(form) {
    var section = form.closest('[data-acgt-root]') || document;
    var success = section.querySelector('[data-acgt-success]');
    form.addEventListener('change', function () { syncAmountButton(form); });
    syncAmountButton(form);

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      setError(form, '');
      var recipient = clean(form.elements['acgt-recipient'].value, 30);
      var organiser = clean(form.elements['acgt-organiser'].value, 30);
      var occasion = clean(form.elements['acgt-occasion'].value, 40);
      var message = clean(form.elements['acgt-message'].value, 140);
      var productId = selectedValue(form, 'acgt-cat');
      var variantId = selectedValue(form, 'acgt-amount');
      var agreed = form.elements['acgt-agree'].checked;

      if (!recipient) return setError(form, t('js_err_recipient'));
      if (!organiser) return setError(form, t('js_err_organiser'));
      if (!variantId) return setError(form, t('js_err_amount'));
      if (!agreed) return setError(form, t('js_err_agree'));

      var code = newCode();
      var url = potUrl(code);
      var props = {};
      props[t('js_prop_gt')] = t('js_pot_for', { name: recipient });
      props[t('js_prop_link')] = url;
      Object.assign(props, {
        _pot: code,
        _pot_role: 'start',
        _pot_for: recipient,
        _pot_by: organiser,
        _pot_occasion: occasion,
        _pot_product: productId === 'later' ? '' : productId,
        _pot_from: organiser,
        _pot_msg: message,
      });
      if (message) props[t('js_prop_msg')] = message;

      var button = form.querySelector('[data-acgt-submit]');
      setBusy(button, true);
      try {
        await addShare(variantId, code, props);
        if (success) {
          success.querySelectorAll('[data-acgt-url]').forEach(function (el) { el.textContent = url.replace(/^https?:\/\//, ''); });
          success.querySelectorAll('[data-acgt-recipient]').forEach(function (el) { el.textContent = recipient; });
          wireShare(success, url, t('js_share_text', { name: recipient }));
          form.hidden = true;
          success.hidden = false;
          success.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.location.href = rootPath() + '/checkout';
        }
      } catch (e) {
        setError(form, e.message);
      } finally {
        setBusy(button, false);
      }
    });
  }

  /* ---------- Pot page ---------- */
  function initPot(root) {
    var data = root.dataset;
    var cur = currency();
    var totalChf = parseFloat(data.total || '0') || 0;
    var goal = parseFloat(data.goal || '0') || 0; /* already in the shopper's currency */
    var total = cur.code === 'CHF' ? totalChf : totalChf * cur.rate;

    root.querySelectorAll('[data-acgt-total]').forEach(function (el) { el.textContent = formatMoney(total, cur.code); });
    if (goal > 0) {
      var pct = Math.max(0, Math.min(100, (total / goal) * 100));
      var left = Math.max(0, goal - total);
      root.querySelectorAll('[data-acgt-bar]').forEach(function (el) {
        requestAnimationFrame(function () { el.style.width = (total > 0 ? Math.max(pct, 3) : 0) + '%'; });
      });
      root.querySelectorAll('[data-acgt-pct]').forEach(function (el) { el.textContent = Math.floor(pct) + '%'; });
      root.querySelectorAll('[data-acgt-left]').forEach(function (el) {
        el.textContent = left > 0.5 ? t('js_to_go', { amount: formatMoney(Math.ceil(left), cur.code) }) : t('js_goal');
      });
      root.classList.toggle('is-complete', left <= 0.5);
    }
    if (cur.code !== 'CHF') {
      root.querySelectorAll('[data-acgt-fx]').forEach(function (el) { el.hidden = false; });
    }

    wireShare(root, window.location.origin + window.location.pathname, t('js_share_text', { name: data.recipient || t('js_cat_lover') }));

    var form = root.querySelector('[data-acgt-join]');
    if (!form) return;
    form.addEventListener('change', function () { syncAmountButton(form); });
    syncAmountButton(form);
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      setError(form, '');
      var name = clean(form.elements['acgt-from'].value, 30);
      var message = clean(form.elements['acgt-message'].value, 140);
      var variantId = selectedValue(form, 'acgt-amount');
      if (!variantId) return setError(form, t('js_err_amount'));
      if (!name) return setError(form, t('js_err_name', { name: data.recipient || t('js_they') }));
      var props = {};
      props[t('js_prop_gt')] = t('js_share_for', { name: data.recipient });
      props[t('js_prop_from')] = name;
      Object.assign(props, {
        _pot: data.code,
        _pot_role: 'join',
        _pot_from: name,
        _pot_msg: message,
      });
      if (message) props[t('js_prop_msg')] = message;
      var button = form.querySelector('[data-acgt-submit]');
      setBusy(button, true);
      try {
        /* Fresh pot state, so the automation adds this share to the latest total */
        var fresh = await fetch(window.location.pathname + window.location.search, { cache: 'no-store' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-acgt-pot]');
            return el ? el.dataset : data;
          })
          .catch(function () { return data; });
        props._pot_gc = fresh.gc || data.gc || '';
        props._pot_prev_total = fresh.total || '0';
        props._pot_prev_count = fresh.count || '0';
        props._pot_prev_msgs = fresh.messages || '';
        await addShare(variantId, data.code, props);
        window.location.href = rootPath() + '/checkout';
      } catch (e) {
        setError(form, e.message);
        setBusy(button, false);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-acgt-start]').forEach(initStart);
    document.querySelectorAll('[data-acgt-pot]').forEach(initPot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();